module.exports = __webpack_public_path__ + "img/5.4e01cab0.jpg";